import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {ForgotPassword as ForgotPasswordRequest} from "../../service/AuthenticationService";
import {useToast} from "../../components/FCObjets/FCToast/FCToast";
import "../Login/Login.scss";

function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const navigate = useNavigate();
    const toast = useToast();

    const onSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!email) return;
        setLoading(true);
        try {
            await ForgotPasswordRequest(email);
            setSubmitted(true);
        } catch {
            // Le back répond toujours 200, mais on gère un éventuel 429 (rate-limit)
            toast.error("Trop de demandes. Réessayez dans quelques minutes.", "Erreur");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="loginPage">
            <div className="loginBg"/>

            <div className="loginCenter">
                <div className="loginMobileLogo">
                    <img src={`${process.env.PUBLIC_URL}/logo_fc.svg`} alt="freeCompta" className="loginMobileIcon"/>
                    <h1 className="loginMobileTitle">Free Compta</h1>
                </div>

                <div className="loginCard">
                    <div className="loginCardHeader">
                        <img src={`${process.env.PUBLIC_URL}/logo_fc.svg`} alt="freeCompta" className="loginCardLogoImg"/>
                        <div className="loginCardLogo">
                            <span className="loginCardLogoText">Free Compta</span>
                        </div>
                    </div>

                    <h2 className="loginCardTitle">Mot de passe oublié</h2>
                    <p className="loginCardSubtitle">
                        {submitted
                            ? "Si un compte est associé à cet email, un lien de réinitialisation vient d'être envoyé."
                            : "Saisissez l'adresse email associée à votre compte. Nous vous enverrons un lien pour réinitialiser votre mot de passe."}
                    </p>

                    {!submitted && (
                        <form onSubmit={onSubmit} className="loginForm">
                            <div className="loginFieldGroup">
                                <label className="loginFieldLabel">Email de contact</label>
                                <div className="loginFieldWrapper">
                                    <span className="material-symbols-outlined loginFieldIcon">mail</span>
                                    <input
                                        className="loginInput"
                                        type="email"
                                        placeholder="vous@exemple.fr"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        autoComplete="email"
                                        required
                                    />
                                </div>
                            </div>

                            <button type="submit" className="loginBtn" disabled={loading}>
                                {loading ? "Envoi…" : "Envoyer le lien →"}
                            </button>

                            <button
                                type="button"
                                className="loginCreateAccount"
                                onClick={() => navigate("/")}
                            >
                                Retour à la connexion
                            </button>
                        </form>
                    )}

                    {submitted && (
                        <div className="loginForm">
                            <button type="button" className="loginBtn" onClick={() => navigate("/")}>
                                Retour à la connexion
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <footer className="loginFooter">
                <a href="mailto:admin@free-compta.fr" className="loginFooterLink">Besoin d'aide ?</a>
                <span className="loginFooterDot">•</span>
                <span>Confidentialité</span>
                <span className="loginFooterDot">•</span>
                <span>© {new Date().getFullYear()} FREECOMPTA.</span>
            </footer>
        </div>
    );
}

export default ForgotPassword;
